<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="wrap container-fuild">
    <!-- 头部顶部 -->
    <div class="header-top container-fuild hidden-xs">
      <div class="comm-wrap clearfix">
        <!-- <img class="logo" src="@/assets/img/logo.png" /> -->

          <img @click="toHome" class="logo" src="@/assets/img/home/logo1.png" style="width: 228px; height: 51px;cursor: pointer" />
          <img class="logo" src="@/assets/img/home/line.png" style="width: 1px;margin: 0 24px" />
          <img class="logo" src="@/assets/img/home/logo2.png" style="width: 405px; height: 60px; margin-top: -10px;"  />
          <img class="logo" src="@/assets/img/home/line.png" style="width: 1px;margin: 0 24px" />
          <img class="logo" src="@/assets/img/home/logo3.png" style="width: 207px; height: 51px"  />
        <div v-if="token" style="display: flex;flex-direction: row;float: right;  padding-right: 10px;font-size: 16px;">
          <span class="pointer" style="font-weight: 600" @click="userInfo">个人中心</span>|
          <span class="pointer" style="font-weight: 600" @click="logout">退出</span>
        </div>
        <div v-if="!token" style="display: flex;flex-direction: row;float: right;  padding-right: 10px;font-size: 16px;">
          <span class="pointer" style="font-weight: 600" @click="registerFun">注册</span>|
          <span class="pointer" style="font-weight: 600" @click="login">登录</span>
        </div>
<!--        <div class="login pull-right">-->
<!--          <span class="pointer">注册</span>|-->
<!--          <span class="pointer">登录</span>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: "Header",
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'token'
    ])
  },
  methods: {
    registerFun() {
      this.$router.push({
        name: 'register'
      })
    },
    toHome() {
      sessionStorage.setItem('navIndex', 0);
      location.href = '/';
    },
    login() {
      this.$router.push({
        name: 'login'
      })
    },
    userInfo() {
      this.$router.push({
        name: 'user'
      })
    },
    async logout() {
      this.$confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          location.href = '/';
        })
      }).catch(() => {});
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #f4f4f4;
  transition: all ease 0.6s;
}
#header .header-top {
  padding-top: 20px;
  height: 90px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #386ACF;
}
.header-top .login {
  padding-right: 10px;
  font-size: 16px;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
#header .header-top .logo {
  float: left;
  width: 480px;
  height: 50px;
}
/* 导航栏 */
#header .header-nav {
  height: 70px;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  display: flex;
  justify-content: space-between;
  margin: 0;
  line-height: 70px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 2px solid #1e73be;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue